import { render, staticRenderFns } from "./create-library.vue?vue&type=template&id=59f483ab&scoped=true&"
import script from "./create-library.vue?vue&type=script&lang=ts&"
export * from "./create-library.vue?vue&type=script&lang=ts&"
import style1 from "./create-library.vue?vue&type=style&index=1&id=59f483ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f483ab",
  null
  
)

export default component.exports